
import React, { useState } from 'react';
import "./About.css";
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

function About() {
    const [openSection, setOpenSection] = useState('Vision');
    const { currentLocal } = useSelector((state) => state.currentLocal);

  const sections = [
    { key: 'Vision', title: currentLocal.home.Vision, content: currentLocal.home.VisionContent },
    { key: 'Mission', title: currentLocal.home.Mission, content: currentLocal.home.MissionContent },
    { key: 'Objectives', title: currentLocal.home.Objectives, content: currentLocal.home.ObjectivesContent },
    { key: 'Values', title: currentLocal.home.Values, content: currentLocal.home.ValuesContent },
  ];



  return (
    <section className='py-5 'style={{backgroundColor:"#faf7f3"}}>
      <Container>
        <h4 className='mb-5 text-center w-text-content'>{currentLocal.home.afaaq}</h4>
        <Row>
          <Col md={3}>
            <div className='d-flex flex-column'>
              {sections.map((section) => (
                <Button
                  key={section.key}
                  onClick={() => setOpenSection(section.key)}
                  className={openSection==section.key?'mb-2 bg_main border-0 text-white border_main':'mb-2 bg-transparent border-0 text-black border_main'}
                >
                  {section.title}
                </Button>
              ))}
            </div>
          </Col>
          <Col md={9}>

                 <div  className='p-3 border_main rounded'style={{whiteSpace: 'pre-line',lineHeight:"32px",}}>
      {openSection=="Vision"?currentLocal.home.VisionContent:openSection=="Mission"?currentLocal.home.MissionContent:openSection=="Objectives"?currentLocal.home.ObjectivesContent :openSection=="Values"&&currentLocal.home.ValuesContent}
                </div> 
    

          </Col>
          </Row>
          </Container>
          </section>      
  )
}

export default About